import { useUsableNetBannerHeight } from '../useUsableNetBannerHeight';
import { useUsableNetScrolling } from '../useUsableNetScrolling';

/**
 * Returns the offset for the usable net banner, when enabled and not scrolled.
 */
export const useUsableNetBannerOffset = () => {
  const usableNetBannerHeight = useUsableNetBannerHeight();

  // Without a banner the offset is zero either way, so don't subscribe.
  const { isScrolled } = useUsableNetScrolling({ skip: usableNetBannerHeight === 0 });

  return isScrolled ? 0 : usableNetBannerHeight;
};
